interface IProps {
    color?: string;
}

export const TopHighLight = (props: IProps) => {
    const { color } = props;

    return (
        <svg width="268" height="91" viewBox="0 0 268 91" fill={color || "#000"} xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.00130653 35.3251C0.000436783 35.3842 0 35.4435 0 35.5028V90.0569H267.5H264.5C261.186 90.0569 258.5 87.3706 258.5 84.0569V82.0569V43.5569C258.5 36.9295 253.127 31.5569 246.5 31.5569H162C159.239 31.5569 157 29.3183 157 26.5569V10.004C157 3.61265 151.087 -1.13826 144.845 0.238917L50.5 21.0569L50.0516 20.9915C45.308 13.234 36.7586 8.05689 27 8.05689C12.0883 8.05689 0 20.1452 0 35.0569C0 35.1464 0.000436783 35.2358 0.00130653 35.3251Z" fill="url(#paint0_linear_6282_57352)" />
            <defs>
                <linearGradient id="paint0_linear_6282_57352" x1="133.75" y1="0" x2="133.75" y2="90.0569" gradientUnits="userSpaceOnUse">
                    <stop stop-opacity="0.9" />
                    <stop offset="1" />
                </linearGradient>
            </defs>
        </svg>

    );
};
